<!-- 
Incluye información de contacto, enlaces a documentos legales (aviso de privacidad, términos de uso) y créditos institucionales. 
-->


<template>
  <div>
    <footer class="footer" :class="this.footer=='footer-dark'?'footer-dark':''">
      <div class="container-fluid">
        <div class="footer-top text-center">
          <div class="footer-links d-flex flex-column flex-md-row justify-content-center align-items-center">
              <a href="#" class="text-muted mb-2 mb-md-0 me-md-3">Aviso de privacidad</a>
              <a href="#" class="text-muted mb-2 mb-md-0 me-md-3">Términos de uso</a>
              <a href="#" class="text-muted">Contacto</a>
            </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 footer-copyright text-center">
            <div class="d-flex flex-column flex-md-row align-items-center justify-content-center mb-2">
              <span class="mb-3 mb-md-0 me-md-4">Innovación, resiliencia y empleo en las MiPYMES</span>
              <img src="../assets/images/verde/footer-r-verde-chica2.png" height="60" class="mt-2 mt-md-0 ms-md-4"/>              
            </div>            
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from '../data/menu';
  import { mapGetters } from 'vuex'
  export default {
    name: 'footerpage',
    data() {
      return {
        customizer: false,
        data:
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
    computed:{
          ...mapGetters({
            footer: 'layout/footer'
          })
        }
  };
</script>
